import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
  {
    id: 1,
    title: "Танилцуулга",
    link: "/taniltsuulga",
  },
  {
    id: 2,
    title: "Үндсэн үйл ажиллагаа",
    link: "",
    submenu: [
      {
        id: 11,
        title: "Дотоод үйл ажиллагаа",
        link: "/dotood-ua",
      },
      {
        id: 12,
        title: "Бүх гишүүдийн цуглаан",
        link: "/tsuglaan",
      },
      {
        id: 13,
        title: "Урлаг спорт",
        link: "/urlag-sport",
      },
      {
        id: 14,
        title: "Сайн дурын үйл ажиллагаа",
        link: "/sain-dur",
      },
      {
        id: 15,
        title: "Бидний амжилт",
        link: "/bidnii-amjilt",
      },
    ],
  },
  {
    id: 3,
    title: "Мэдээ мэдээлэл",
    link: "/medee-medeelel",
  },
  {
    id: 4,
    title: "Холбоо барих",
    link: "/bidentei-holbogdoh",
  },
];

const MobileMenu = () => {
  const [openId, setOpenId] = useState(0);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <ul className="main_menu_list clearfix">
      {menus.map((item, mn) => {
        return (
          <ListItem className={item.id === openId ? "active" : null} key={mn}>
            {item.submenu ? (
              <Fragment>
                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                  {item.title}
                  <i
                    className={item.id === openId ? "ti-minus" : "ti-plus"}
                  ></i>
                </p>
                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                  <List className="subMenu">
                    <Fragment>
                      {item.submenu.map((submenu, i) => {
                        return (
                          <ListItem key={i}>
                            <Link
                              onClick={ClickHandler}
                              className="active"
                              to={submenu.link}
                            >
                              {submenu.title}
                            </Link>
                          </ListItem>
                        );
                      })}
                    </Fragment>
                  </List>
                </Collapse>
              </Fragment>
            ) : (
              <Link className="active" to={item.link}>
                {item.title}
              </Link>
            )}
          </ListItem>
        );
      })}
    </ul>
  );
};

export default MobileMenu;
